/**
 * P3-32: Order of the Sun 面板（praise / adore / transcend / religion upgrades）。
 */
import { useGameTick } from "../../bridge/useGameTick";
import type { GamePage } from "../../bridge/GameBridge";
import { Panel } from "../../components/Panel";
import { t } from "../../bridge/i18n";
import { Fragment } from "react";
import { FaithCounter } from "./FaithCounter";
import { PraiseButton } from "./PraiseButton";
import { AdoreButton } from "./AdoreButton";
import { TranscendButton } from "./TranscendButton";
import { ReligionUpgradeButton } from "./ReligionUpgradeButton";

export function OrderOfTheSunPanel() {
  const upgrades = useGameTick(
    (game: GamePage | null) =>
      (game?.religion as { religionUpgrades?: { name: string }[] } | null)?.religionUpgrades ?? [],
  );

  return (
    <Panel title={t("religion.panel.orderOfTheSun.label")}>
      <FaithCounter />
      <PraiseButton handler={() => {
        const g = window.gamePage;
        g?.religion?.praise?.();
      }} />
      <AdoreButton handler={() => {
        const g = window.gamePage;
        g?.religion?.resetFaith?.(1.01, true);
      }} />
      {upgrades.map((upgr) => (
        <Fragment key={upgr.name}>
          <ReligionUpgradeButton upgradeName={upgr.name} />
          {upgr.name === "transcendence" && (
            <TranscendButton handler={() => {
              const g = window.gamePage;
              g?.religion?.transcend?.();
            }} />
          )}
        </Fragment>
      ))}
    </Panel>
  );
}
